module.exports = __webpack_public_path__ + "static/media/six.e3c142f1.svg";